// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper---MBwfl","content":"content---sSA3T"};